const styles = (theme) => ({
  tabBox: {
    width: '100%',
    padding: theme.spacing(0, 2.5),
  },
  tabElement: {
    width: 'fit-content',
  },
  tabTitle: {
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: theme.spacing(0, 0, 1.25, 0),
  },
  tabDivider: {
    height: 4,
    backgroundColor: theme.color.black,
  },
});

export default styles;
